import React                from "react";
import PropTypes            from "prop-types";
import Store                from "Dashboard/Core/Store";
import useForm              from "Dashboard/Hooks/Form";
import useDialog            from "Dashboard/Hooks/Dialog";
import { Member }           from "Utils/API";

// Dashboard
import EditDialog           from "Dashboard/Components/Dialogs/EditDialog";
import InputField           from "Dashboard/Components/Form/InputField";



/**
 * The Member Edit Dialog
 * @param {Object} props
 * @returns {React.ReactElement}
 */
function MemberEdit(props) {
    const { open, elemID, trainingWhiteListID, onClose, onSubmit } = props;

    const { statuses } = Store.useState("trainingMember");
    const { editElem } = Store.useAction("trainingMember");


    // The Initial Data
    const initialData = {
        trainingMemberID    : 0,
        trainingWhiteListID : 0,
        memberNumber        : "",
        memberName          : "",
        description         : "",
        status              : "Active",
    };

    // Handles the Edit
    const handleEdit = (data) => {
        if (trainingWhiteListID) {
            return editElem({ ...data, trainingWhiteListID });
        }
        return editElem({ ...data });
    };

    // The Form State
    const {
        data, errors, setElem, handleChange, handleSubmit,
    } = useForm("trainingMember", initialData, handleEdit, onSubmit);

    // Load the Data
    const { loading } = useDialog("trainingMember", open, elemID, null, setElem);



    // Do the Render
    return <EditDialog
        open={open}
        icon="training"
        title={elemID ? "TRAININGS_MEMBERS_EDIT_TITLE" : "TRAININGS_MEMBERS_CREATE_TITLE"}
        error={errors.form}
        onSubmit={handleSubmit}
        onClose={onClose}
        isLoading={loading}
        isNarrow
    >
        <InputField
            type="suggest"
            name="memberName"
            label="GENERAL_MEMBER"
            value={data.memberName}
            error={errors.memberNumber}
            suggestID="memberNumber"
            suggestFetch={Member.search}
            onChange={handleChange}
            isRequired
        />
        <InputField
            type="textarea"
            name="description"
            label="GENERAL_DESCRIPTION"
            value={data.description}
            error={errors.description}
            onChange={handleChange}
        />
        <InputField
            type="select"
            name="status"
            label="GENERAL_STATUS"
            options={statuses}
            value={data.status}
            error={errors.status}
            onChange={handleChange}
            hideClear
            isRequired
        />
    </EditDialog>;
}

/**
 * The Property Types
 * @typedef {Object} propTypes
 */
MemberEdit.propTypes = {
    open                : PropTypes.bool.isRequired,
    onClose             : PropTypes.func.isRequired,
    onSubmit            : PropTypes.func.isRequired,
    elemID              : PropTypes.number,
    trainingWhiteListID : PropTypes.number,
};

export default MemberEdit;
